(() => {
  const terms = ['Protéines', 'Collagène', 'Magnésium', 'Longévité', 'Énergie', 'Sommeil', 'Perte de poids'];
  const fallback = 'Rechercher';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const timers = new WeakMap();

  const clearTimer = (input) => {
    const handles = timers.get(input);
    if (handles?.timeout) window.clearTimeout(handles.timeout);
    if (handles?.idle && 'cancelIdleCallback' in window) {
      window.cancelIdleCallback(handles.idle);
    }
    timers.delete(input);
  };

  const schedule = (input, callback, delay) => {
    clearTimer(input);
    const handles = {};

    handles.timeout = window.setTimeout(() => {
      handles.timeout = null;

      if ('requestIdleCallback' in window) {
        handles.idle = window.requestIdleCallback(callback, { timeout: 500 });
      } else {
        callback();
      }
    }, delay);

    timers.set(input, handles);
  };

  const animate = (input) => {
    if (input.dataset.yamSearchAnimated === 'true') return;
    input.dataset.yamSearchAnimated = 'true';
    input.placeholder = fallback;

    if (reduceMotion) return;

    let termIndex = 0;
    let letterIndex = 0;
    let deleting = false;

    const tick = () => {
      if (document.activeElement === input || input.value) {
        input.placeholder = fallback;
        schedule(input, tick, 180);
        return;
      }

      const term = terms[termIndex];

      if (!deleting) {
        letterIndex += 1;
        input.placeholder = term.slice(0, letterIndex);

        if (letterIndex === term.length) {
          deleting = true;
          schedule(input, tick, 1350);
          return;
        }

        schedule(input, tick, 85);
        return;
      }

      letterIndex -= 1;
      input.placeholder = term.slice(0, Math.max(0, letterIndex));

      if (letterIndex === 0) {
        deleting = false;
        termIndex = (termIndex + 1) % terms.length;
        schedule(input, tick, 120);
        return;
      }

      schedule(input, tick, 42);
    };

    input.addEventListener('focus', () => {
      clearTimer(input);
      input.placeholder = fallback;
    });

    input.addEventListener('blur', () => {
      if (!input.value) {
        deleting = false;
        letterIndex = 0;
        schedule(input, tick, 350);
      }
    });

    input.addEventListener('input', () => {
      if (input.value) input.placeholder = fallback;
    });

    schedule(input, tick, 500);
  };

  const init = (root = document) => {
    root.querySelectorAll('input.search__input[type="search"]').forEach(animate);
  };

  const polishMenu = (root = document) => {
    root.querySelectorAll('.tmenu_item--root > .tmenu_item_link[title]').forEach((link) => {
      link.removeAttribute('title');
    });
  };

  const refresh = (root = document) => {
    init(root);
    polishMenu(root);
  };

  const scheduleRefresh = (delay) => {
    window.setTimeout(() => {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(() => refresh(), { timeout: 500 });
      } else {
        refresh();
      }
    }, delay);
  };

  const start = () => {
    refresh();
    scheduleRefresh(1000);
    scheduleRefresh(3000);
    document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
